import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { NotificationModalComponent } from 'src/app/components/modals/success/notification-modal.component';
import { NavigationComponent } from 'src/app/components/navigation/navigation.component';
import { navigationKey } from 'src/app/reducers/navigation/navigation.reducer';
import { SharedModule } from 'src/app/shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { ActionFooterComponent } from 'src/app/components/action-footer/action-footer.component';
import { IonicModule } from '@ionic/angular';
import { navigationReducer } from '../../reducers/navigation/navigation.reducer';
import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';

import { SchedulesEffects } from './views/activities/reducers/schedules/schedules.effect';
import { CalendarsEffects } from './views/schedule/reducers/calendars/calendars.effect';
import { calendarReducer, calendarsKey, roleReducer, rolesKey } from './views/schedule/reducers/calendars/calendars.reducer';
import { schedulesKey, schedulesReducer, staffKey, staffReducer, activityKey, activityReducer, bookingMemberKey, bookingMembersListReducer } from './views/activities/reducers/schedules/schedules.reducer';
import { updateEventKey, updateEventReducer } from './views/activities/reducers/update/update.reducer';
import { TasksEffects } from './views/schedule/reducers/tasks/tasks.effect';
import { tasksKey, tasksReducer } from './views/schedule/reducers/tasks/tasks.reducer';
import { qrEventKey, qrEventReducer } from './views/activities/reducers/qr/qr.reducer';
import { UpdateActivityEffects } from './views/schedule/reducers/update/update.effect';
import { updateActivityKey, updateActivtyReducer } from './views/schedule/reducers/update/update.reducer';
import { listMemberKey, listMemberReducer } from './reducers/list-members/list-members.reducer';
import { UpdateEffects } from './views/activities/reducers/update/update.effects';
import { ListMemberEffects } from './reducers/list-members/list-members.effect';
import { QrEffects } from './views/activities/reducers/qr/qr.effect';
import { tasksDetailKey, tasksDetailReducer } from './views/schedule/reducers/task-detail/tasks-detail.reducer';
import { TasksDetailEffects } from './views/schedule/reducers/task-detail/task-detail.effect';
import {manageMemberFeeKey, manageMemberFeeReducer} from './views/activities/reducers/fees/fees.reducer';
import {FeesEffects} from './views/activities/reducers/fees/fees.effects';

@NgModule({
    imports : [
        SharedModule,
        MainRoutingModule,
        IonicModule,
        StoreModule.forFeature(schedulesKey, schedulesReducer),
        StoreModule.forFeature(staffKey, staffReducer),
        StoreModule.forFeature(activityKey, activityReducer),

        StoreModule.forFeature(navigationKey, navigationReducer),

        StoreModule.forFeature(updateEventKey, updateEventReducer),
        StoreModule.forFeature(bookingMemberKey, bookingMembersListReducer),
        StoreModule.forFeature(listMemberKey, listMemberReducer),
        StoreModule.forFeature(qrEventKey, qrEventReducer),
        StoreModule.forFeature(tasksKey, tasksReducer),
        EffectsModule.forFeature([SchedulesEffects, UpdateEffects, ListMemberEffects, QrEffects]),
        StoreModule.forFeature(calendarsKey, calendarReducer),
        StoreModule.forFeature(rolesKey, roleReducer),
        EffectsModule.forFeature([TasksEffects, CalendarsEffects]),
        StoreModule.forFeature(updateActivityKey, updateActivtyReducer),
        EffectsModule.forFeature([UpdateActivityEffects]),
        StoreModule.forFeature(tasksDetailKey, tasksDetailReducer),
        EffectsModule.forFeature([TasksDetailEffects]),
        StoreModule.forFeature(navigationKey, navigationReducer),
        StoreModule.forFeature(manageMemberFeeKey, manageMemberFeeReducer),
        EffectsModule.forFeature([FeesEffects])
    ],
    declarations: [
        MainComponent,
        NavigationComponent,
        ActionFooterComponent,
        FooterComponent,
        NotificationModalComponent
    ],
    providers: []
})
export class MainModule { }
